import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import CONFIG from './config'

firebase.initializeApp(CONFIG.firebase)

export const ref = firebase.database().ref()
export const storageRef = firebase.storage().ref()
export const firebaseAuth = firebase.auth



// WEBPACK FOOTER //
// ./src/config/firebase.js